import BaseView from "./_BaseView";
import Table from "../components/Table";

export default class JumpsView extends BaseView {
    init() {
        super.init();

        const container = $('#appJumpsTable');
        if (container.length > 0) {
            const datepicker = $('#appJumpsTable input[name="daterange"]');
            flatpickr('#appJumpsTable input[name="daterange"]', {
                mode: 'range'
            });


            datepicker.trigger('change');

            container.find('.reset').on('click', function () {
                datepicker.val(datepicker.data('default')).trigger('change');
                return false;
            });

            this.table = new Table('appJumpsTable', '/api/guides/jumps', [
                {data: 'title', orderable: true},
                {data: 'started'},
                {data: 'completed'},
                {data: 'tools', orderable: false},
            ]);
        }
    }
}
